import React from 'react';
import Link from 'next/link';
import Icon from '@/components/ui/AppIcon';

const CTASection: React.FC = () => {
  return (
    <section className="py-16 bg-gradient-to-br from-brand-primary via-secondary to-primary">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto text-center">
          <div className="inline-flex items-center space-x-2 px-4 py-2 bg-white/10 backdrop-blur-sm rounded-full mb-6">
            <Icon name="SparklesIcon" size={20} className="text-white" variant="solid" />
            <span className="text-sm font-cta font-semibold text-white">Ready to Transform Your Business?</span>
          </div>

          <h2 className="text-3xl lg:text-4xl xl:text-5xl font-headline font-bold text-white mb-6 leading-tight">
            Get Your Free Industry-Specific IT Assessment
          </h2>

          <p className="text-lg lg:text-xl text-white/90 font-body mb-8 max-w-3xl mx-auto leading-relaxed">
            Our experts will analyze your current infrastructure, identify opportunities for improvement, and create a customized roadmap tailored to your industry's unique requirements
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <Link
              href="/contact"
              className="inline-flex items-center space-x-2 px-8 py-4 bg-white hover:bg-white/90 text-brand-primary rounded-lg font-cta font-semibold text-lg shadow-elevated transition-all duration-300 transform hover:scale-105"
            >
              <Icon name="CalendarIcon" size={24} variant="outline" />
              <span>Schedule Free Assessment</span>
            </Link>

            <Link
              href="/services-overview"
              className="inline-flex items-center space-x-2 px-8 py-4 bg-white/10 hover:bg-white/20 backdrop-blur-sm text-white border-2 border-white/30 rounded-lg font-cta font-semibold text-lg transition-all duration-300"
            >
              <Icon name="DocumentTextIcon" size={24} variant="outline" />
              <span>View All Services</span>
            </Link>
          </div>

          <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-6 max-w-3xl mx-auto">
            <div className="flex items-center justify-center space-x-3 text-white/90">
              <Icon name="CheckCircleIcon" size={24} variant="solid" />
              <span className="text-sm font-body">No Obligation</span>
            </div>
            <div className="flex items-center justify-center space-x-3 text-white/90">
              <Icon name="ClockIcon" size={24} variant="solid" />
              <span className="text-sm font-body">30-Minute Consultation</span>
            </div>
            <div className="flex items-center justify-center space-x-3 text-white/90">
              <Icon name="ShieldCheckIcon" size={24} variant="solid" />
              <span className="text-sm font-body">Confidential Analysis</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;